import { render, staticRenderFns } from "./DesktopBudgetFilter.vue?vue&type=template&id=7745aa12&"
import script from "./DesktopBudgetFilter.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DesktopBudgetFilter.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DesktopBudgetFilter.vue?vue&type=style&index=0&id=7745aa12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports